import { AccountPeopleProfile } from 'api/account-people/profile-type';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Collapsible, EmptyContent } from './collapsible-section';
import { TextWithCitations } from '../text-with-citations';

interface Props {
  userProfile: AccountPeopleProfile;
}
const Wrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-03);
  padding-left: var(--spacing-05);
  list-style: disc;
  p {
    font-size: inherit !important;
    font-weight: inherit !important;
    line-height: inherit !important;
    letter-spacing: inherit !important;
  }
`;

export const LikesAndInterests: React.FC<Props> = ({
  userProfile: { userEngagementData },
}) => {
  const likesAndInterests = userEngagementData?.likesAndInterests;
  const isEmpty = likesAndInterests == null || likesAndInterests.length === 0;

  return (
    <Collapsible title="Likes and interests" panelKey="likes-and-interests">
      {isEmpty ? (
        <EmptyContent>
          <FormattedMessage id="account.people.profile.sections.likes_and_interests.empty" />
        </EmptyContent>
      ) : (
        <Wrapper>
          {likesAndInterests.map((item, index) => (
            <li key={index}>
              <TextWithCitations
                value={item.likesAndInterest}
                citationMapping={item.citationMapping}
              />
            </li>
          ))}
        </Wrapper>
      )}
    </Collapsible>
  );
};
